<template>
  <modal name="add-user" adaptive height="auto" @opened="clearForm" @closed="$emit('clearEdit')">
    <Wrapper>
      <template v-slot:header-title>
        <i class="icon--edit" v-if="edit"></i>
        <i class="icon--plus" v-else></i>
        {{ (edit ? $t('general.edit') : $t('general.create')) + ' ' + $t('general.user')}}
      </template>
      <ValidationObserver ref="form" v-slot="{ invalid }" tag="form" class="form__wrapper">
        <div class="field__row">
          <Field :label="$t('general.name')"
                 name="name"
                 rules="required|max:255"
                 type="text"
                 v-model="form.name"/>
        </div>
        <div class="field__row">
          <Field :label="$t('general.email')"
                 name="email"
                 :rules="{
                  required: true,
                  email: true,
                  max: '255',
                  unique: {ignore: edit ? edit.uuid: false}
                 }"
                 type="email"
                 v-model="form.email"/>
        </div>
        <div class="field__row">
          <FieldSelect :label="$t('general.role')"
                       name="role"
                       :items="rolesList"
                       rules="required"
                       :placeholder="$t('users.select_role')"
                       v-model="form.role"/>
        </div>

        <div class="btn--bar">
          <template v-if="!edit">
            <button type="button" @click="saveForm()" :disabled="invalid || submit" class="btn">
              <i class="icon--check"></i> {{ $t('general.save') }}
            </button>
          </template>
          <template v-else>
            <button type="button" @click="editForm()" :disabled="invalid || submit" class="btn">
              <i class="icon--check"></i> {{ $t('general.save') }}
            </button>
          </template>
          <span class="btn btn--secondary" @click="$emit('hideModal')"><i class="icon--cancel"></i>  {{ $t('general.close') }}</span>
        </div>

      </ValidationObserver>
    </Wrapper>
  </modal>
</template>

<script>
import Field from '@/components/Parts/Field'
import Wrapper from '@/components/Modal/Wrapper'
import FieldSelect from '@/components/Parts/FieldSelect'
import { ROLES } from '@/constants'
import { errHandler } from '@/helpers'

export default {
  name: 'Modal-User',
  props: {
    edit: {
      type: [Boolean, Object],
      default: false
    }
  },
  mounted () {
    const list = this.$store.getters['auth/role'] === ROLES.MANAGER.ROLE_MANAGER ? ROLES.MANAGER : ROLES.COMPANY
    this.rolesList = Object.values(list).map(item => {
      return {
        id: item,
        name: this.$t(`users.roles.${item}`)
      }
    })
  },
  components: { FieldSelect, Field, Wrapper },
  data () {
    return {
      form: {
        name: '',
        email: '',
        role: ''
      },
      rolesList: [],
      submit: false
    }
  },
  computed: {},
  methods: {
    async saveForm () {
      this.submit = true
      if (await this.$refs.form.validate()) {
        try {
          await this.$store.dispatch('user/add', this.form)
          this.$toasted.global.success_message({
            message: this.$t('users.userCreateSuccess')
          })
          this.$emit('hideModal')
          this.$emit('init')
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    },
    async editForm () {
      this.submit = true
      if (await this.$refs.form.validate()) {
        try {
          await this.$store.dispatch('user/update', {
            uuid: this.edit.uuid,
            form: this.form
          })
          this.$toasted.global.success_message({
            message: this.$t('users.userUpdateSuccess')
          })
          this.$emit('hideModal')
          this.$emit('init')
        } catch (e) {
          errHandler(e, this.$toasted, key => this.$t(key))
        } finally {
          this.submit = false
        }
      }
    },
    clearForm () {
      this.$nextTick(() => {
        if (!this.edit) {
          this.form = {
            name: '',
            email: '',
            role: ''
          }
        } else {
          this.form = {
            name: this.edit.name,
            email: this.edit.email,
            role: this.edit.role
          }
        }

        requestAnimationFrame(() => {
          this.$refs.form.reset()
        })
      })
    }
  }
}
</script>

<style scoped>

</style>
